import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import DialogModal from '../helpers/DialogModal';

interface SaveBuildModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  currentBuildName?: string;
}

const SaveBuildModal: React.FC<SaveBuildModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentBuildName
}) => {
  const [buildName, setBuildName] = useState(currentBuildName ?? '');

  useEffect(() => {
    if (isOpen) {
      setBuildName(currentBuildName ?? '');
    }
  }, [isOpen, currentBuildName]);

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (buildName.trim()) {
      onSave(buildName.trim());
    }
  };

  return (
    <DialogModal
      isOpen={isOpen}
      onClose={onClose}
      title={currentBuildName ? 'Update Build Name' : 'Save Build'}
      size="lg"
      primaryAction={{
        label: currentBuildName ? 'Update' : 'Save',
        onClick: () => handleSubmit(),
        disabled: !buildName.trim(),
        icon: <Check className="w-5 h-5" />,
        type: 'submit' // Although DialogModal uses button type="button" by default for action, we can override or just use onClick.
                       // Actually my DialogModal implementation supports type.
      }}
      secondaryAction={{
        label: 'Cancel',
        onClick: onClose
      }}
    >
      <form onSubmit={handleSubmit} className="mb-2">
        <div className="mb-1">
          <label className="block text-sm font-medium text-sworn-gold mb-2">
            Build Name
          </label>
          <input
            type="text"
            value={buildName}
            onChange={(e) => setBuildName(e.target.value)}
            placeholder="Enter build name..."
            className="w-full p-3 rounded-lg bg-slate-800 text-white border border-sworn-brown focus:ring-2 focus:ring-sworn-gold focus:border-transparent"
             autoFocus
            maxLength={50}
          />
        </div>
        {/* Hidden submit button to enable "Enter" key submission within the form */}
        <button type="submit" className="hidden" aria-hidden="true" tabIndex={-1}>Submit</button>
      </form>
    </DialogModal>
  );
};

export default SaveBuildModal;
